module.exports = __webpack_public_path__ + "img/1577437611.de07ccc0.jpg";